import { __extends } from "tslib";
import { Plot } from '../../core/plot';
import { adaptor } from './adaptor';
/**
 *  弦图 Chord
 */

var Chord =
/** @class */
function (_super) {
  __extends(Chord, _super);

  function Chord() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** 图表类型 */


    _this.type = 'chord';
    return _this;
  }

  Chord.prototype.getDefaultOptions = function () {
    return {
      nodeStyle: {
        opacity: 1,
        fillOpacity: 1,
        lineWidth: 1
      },
      edgeStyle: {
        opacity: 0.5,
        lineWidth: 2
      },
      label: {
        fields: ['x', 'name'],
        callback: function callback(x, name) {
          var centerX = (x[0] + x[1]) / 2;
          var offsetX = centerX > 0.5 ? -4 : 4;
          return {
            labelEmit: true,
            style: {
              fill: '#8c8c8c'
            },
            offsetX: offsetX,
            content: name
          };
        }
      },
      tooltip: {
        fields: ['source', 'target', 'value'],
        formatter: function formatter(datum) {
          var source = datum.source,
              target = datum.target,
              value = datum.value;
          return {
            name: source + " -> " + target,
            value: value
          };
        }
      },
      interactions: [{
        type: 'element-active'
      }],
      weight: true,
      nodePaddingRatio: 0.1,
      nodeWidthRatio: 0.05
    };
  };
  /**
   * 获取适配器
   */


  Chord.prototype.getSchemaAdaptor = function () {
    return adaptor;
  };

  return Chord;
}(Plot);

export { Chord };